import styled from 'styled-components';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';

export const TextFlow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const ParagraphSmallHeavy = styled(Paragraph).attrs({ typography: 'ParagraphSmallHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const ParagraphXSmallRegular = styled(Paragraph).attrs({ typography: 'ParagraphXsmallRegular' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  line-height: 20px;
`;

export const ParagraphXSmallHeavy = styled(Paragraph).attrs({ typography: 'ParagraphXsmallHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  font-size: 1rem;
  line-height: 1.25;
`;

export const ParagraphBaseHeavy = styled(Paragraph).attrs({ typography: 'ParagraphBaseHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
`;

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colorPrimaryPrimary10};
`;

export const InlineLink = styled.a`
  font-weight: 600;

  &,
  &:visited {
    color: ${({ theme }) => theme.colorActionPrimaryDefault};
  }

  &:hover {
    color: ${({ theme }) => theme.colorActionPrimaryHover};
  }

  &:active {
    color: ${({ theme }) => theme.colorActionPrimaryActive};
  }
`;
